import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures every route change scrolls the window to the top.
 * Mount once inside <BrowserRouter>.
 *
 * Uses useLayoutEffect for an immediate scroll before the browser paints,
 * plus a delayed fallback so lazy-loaded page content doesn't push the
 * viewport back down after it mounts.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  useEffect(() => {
    // Lazy-loaded chunks can shift layout after the initial scroll.
    const id = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 100);
    return () => clearTimeout(id);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
